module.exports = ['$scope', '$http', function($scope, $http) {
    $scope.testclick = function() {
        alert('worked uh huh2');
    }
    $scope.redirectHome = function(){
        location.replace("/member/home/");
    }
}];